/**
 * The space needed for rendering axes and a little bit of padding
 */
export const margin = { top: 10, right: 10, bottom: 40, left: 45 };
